import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggle(_event) {
    const details = this.element;
    if (!details.open) {
      details.open = true;
    } else {
      details.open = false;
    }
  }

  close(event) {
    const details = this.element;
    details.open = false;
    event.preventDefault();
  }

  autoClose(_event) {
    this.element.open = false;
  }
}
